(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-review-form"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('pwRevForm');if(!root)return;
  var q=new URLSearchParams(location.search);
  var ctx={o:q.get('o'),p:q.get('p'),e:q.get('e'),t:q.get('t')},rating=0;
  function show(name){root.querySelectorAll('[data-step]').forEach(function(el){el.hidden=el.dataset.step!==name})}
  if(!ctx.o||!ctx.p||!ctx.t){show('invalid');return}
  root.querySelectorAll('.pw-revform__star').forEach(function(b){
    b.addEventListener('click',function(){
      rating=parseInt(b.dataset.rate,10);
      root.querySelectorAll('.pw-revform__star').forEach(function(x,i){x.classList.toggle('is-on',i<rating)});
      setTimeout(function(){show(rating>=4?'review':'sav')},250);
    });
  });
  function toB64(file){return new Promise(function(res,rej){
    if(file.size>4*1024*1024)return rej(new Error('Photo trop lourde (4 Mo max)'));
    var r=new FileReader();r.onload=function(){res({name:file.name,data:r.result})};r.onerror=rej;r.readAsDataURL(file)})}
  root.querySelectorAll('form').forEach(function(f){
    f.addEventListener('submit',function(ev){
      ev.preventDefault();
      var btn=f.querySelector('button[type=submit]');btn.disabled=true;var old=btn.textContent;btn.textContent='Envoi...';
      var photosInput=f.querySelector('input[type=file]');
      var photos=photosInput?[].slice.call(photosInput.files,0,2):[];
      Promise.all(photos.map(toB64)).then(function(encoded){
        return fetch(root.dataset.webhook,{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({kind:f.dataset.step,rating:rating,body:f.elements.body.value,
            order_id:ctx.o,product_id:ctx.p,email_b64:ctx.e,token:ctx.t,photos:encoded})});
      }).then(function(r){
        if(r.status===409)return show('invalid');
        if(!r.ok)throw new Error('HTTP '+r.status);
        show(f.dataset.step==='review'?'done-review':'done-sav');
      }).catch(function(err){btn.disabled=false;btn.textContent=old;alert(err.message||'Erreur, réessaie.')});
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
